import React from 'react'
import { Spinner } from '@dehaat/dds'
import { RequestAction } from 'app/constants/request'
import DemoBulkActionBar from './DemoBulkActionBar'
import DemoApproveConfirmModal from './DemoApproveConfirmModal'
import DemoActionResultModal from './DemoActionResultModal'
import DemoRejectReasonDrawer from './DemoRejectReasonDrawer'

type Props = {
  styles: any
  actionLoading: boolean
  isMultiSelectEnabled: boolean
  statusFilter: string
  pendingStatusFilter: string
  roleType?: string
  selectedRequestIds: number[]
  pendingAction: RequestAction | null
  showConfirmModal: boolean
  showListResultPopup: boolean
  listResultMessage: string
  showRejectDrawer: boolean
  otherReason: string
  rejectValidationError: string
  onOpenReject: () => void
  onTriggerApprove: () => void
  onCloseConfirmModal: () => void
  onConfirmApprove: () => void
  onCloseListResult: () => void
  onCloseRejectDrawer: () => void
  onSetOtherReason: (value: string) => void
  onSetRejectValidationError: (value: string) => void
  onRejectSubmit: () => void
  enforceCharacterLimit: (value: string, maxLength?: number) => string
}

const DemoMaterialRequestActionsPanel = ({
  styles,
  actionLoading,
  isMultiSelectEnabled,
  statusFilter,
  pendingStatusFilter,
  roleType,
  selectedRequestIds,
  pendingAction,
  showConfirmModal,
  showListResultPopup,
  listResultMessage,
  showRejectDrawer,
  otherReason,
  rejectValidationError,
  onOpenReject,
  onTriggerApprove,
  onCloseConfirmModal,
  onConfirmApprove,
  onCloseListResult,
  onCloseRejectDrawer,
  onSetOtherReason,
  onSetRejectValidationError,
  onRejectSubmit,
  enforceCharacterLimit,
}: Props) => {
  return (
    <>
      {actionLoading && <Spinner type="on-screen" />}
      <DemoBulkActionBar
        styles={styles}
        isMultiSelectEnabled={isMultiSelectEnabled}
        statusFilter={statusFilter}
        pendingStatusFilter={pendingStatusFilter}
        roleType={roleType}
        selectedRequestIds={selectedRequestIds}
        onOpenReject={onOpenReject}
        onTriggerApprove={onTriggerApprove}
      />
      <DemoApproveConfirmModal
        styles={styles}
        isVisible={showConfirmModal}
        actionLoading={actionLoading}
        pendingAction={pendingAction}
        selectedCount={selectedRequestIds.length}
        onClose={onCloseConfirmModal}
        onConfirm={onConfirmApprove}
      />
      <DemoActionResultModal
        styles={styles}
        isVisible={showListResultPopup}
        message={listResultMessage}
        onClose={onCloseListResult}
      />
      <DemoRejectReasonDrawer
        styles={styles}
        visible={showRejectDrawer}
        actionLoading={actionLoading}
        otherReason={otherReason}
        rejectValidationError={rejectValidationError}
        onClose={onCloseRejectDrawer}
        onSetOtherReason={onSetOtherReason}
        onSetRejectValidationError={onSetRejectValidationError}
        onRejectSubmit={onRejectSubmit}
        enforceCharacterLimit={enforceCharacterLimit}
      />
    </>
  )
}

export default DemoMaterialRequestActionsPanel
